import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { Button } from "components/ui/button";
import { SaveAll } from "lucide-react";
import EmailReview from "../../../../email-review";
import PartialOperatorBalance from "../../../../partial-operator-balance";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { FaRegUser } from "react-icons/fa6";

interface ActionButtonsProps {
  actions: Array<{
    label: string;
    onclick: () => void;
  }>;
  isClosed: boolean;
  isAdmin: boolean;
  isLoading: boolean;
  isSaveLoading: boolean;
  onAddDivergence: () => void;
  onSaveAll: () => void;
  conciliation_id?: string;
}

const buttonClasses = "rounded border-none disabled:cursor-not-allowed disabled:opacity-50";

export function ActionButtons({
  actions,
  isClosed,
  isAdmin,
  isLoading,
  isSaveLoading,
  onAddDivergence,
  onSaveAll,
  conciliation_id,
}: ActionButtonsProps) {

  const { handleModal } = useDialogModal()

  const openHandleEmailReview = () => {
    handleModal(
      {
        isOpen: true,
        element: <EmailReview conciliation_id={conciliation_id} />,
        title: "Revisar Emails"
      }
    )
  }

  const openPartialOperatorBalance = () => {
    handleModal(
      {
        isOpen: true,
        element: <PartialOperatorBalance conciliation_id={conciliation_id} />,
        title: "Saldo Parcial Caixa"
      }
    )
  }

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
      <div className="flex flex-wrap gap-2">
        {actions.map((action) => (
          <Button
            key={action.label}
            className={buttonClasses}
            onClick={action.onclick}
          >
            {action.label}
          </Button>
        ))}
        <Button
          onClick={openHandleEmailReview}
          className=""
          title="E-mails Enviados"
        >
          <MdOutlineMarkEmailRead />
        </Button>
        <Button
          onClick={openPartialOperatorBalance}
          className=""
          title="Saldo Parcial Caixa"
        >
          <FaRegUser />
        </Button>
      </div>
      {!isClosed && (
        <div className="flex flex-wrap items-end justify-end gap-2">
          {isAdmin && (
            <Button className={buttonClasses} onClick={onAddDivergence}>
              Adicionar divergência
            </Button>
          )}
          <Button
            className="bg-[#2B0C1A] text-white hover:bg-[#2B0C1A]/85 flex gap-2"
            onClick={onSaveAll}
            disabled={isLoading || isSaveLoading}
          >
            <SaveAll />
            Salvar Todos
          </Button>
        </div>
      )}
    </div>
  );
}
